import React, { useEffect, useState } from 'react'
import useQuestionnaire from '../hooks/questionnairs/questionnaire'
import { useNavigate, useParams } from 'react-router-dom'

export default function Questionnaire() {
    let [isSubmit, setIsSubmit] = useState(false)
    let {
        getQuestionnaireById,
        submitQuestionnaire,
        questionnaire,
        setQuestionnaire,
        submit,
        setSubmit,
    } = useQuestionnaire()
    let params = useParams()
    let navigate = useNavigate()

    useEffect(() => {
        if (questionnaire.statusCode === "GET_QUESTIONNAIRE_SUCCESS") {
            setQuestionnaire({
                ...questionnaire,
                statusCode: "STAND_BY"
            })
        }
        // console.log(questionnaire)
        // eslint-disable-next-line
    }, [questionnaire.statusCode])

    useEffect(() => {
        if (submit.statusCode === "SUBMIT_QUESTIONNAIRE_SUCCESS") {
            alert("Submit Complete.")
            navigate("/rewards")
        } else if (submit.statusCode === "SUBMIT_QUESTIONNAIRE_FAIL") {
            alert(submit.msg)
        }
        setSubmit({
            ...submit,
            statusCode: "STAND_BY"
        })
        setIsSubmit(false)
        // eslint-disable-next-line
    }, [submit.statusCode])

    useEffect(() => {
        let id = params.id
        getQuestionnaireById(id)
        // eslint-disable-next-line
    }, [])
    console.log(questionnaire.status)
    if (questionnaire.status === 429) return (<div className='container'>
        <br />
        <h1 align="center">มีผู้ตอบแบบสอบถามครบตามจำนวนแล้ว</h1>
        <div className='row'>
            <div className='col-md-4'></div>
            <div className='col-12 col-xs-12 col-sm-12 col-md-4'>
            </div>
        </div>
    </div>)
    else if (!questionnaire.data)
        return (
            <div className='container'>
                <br />
                <h1 align="center">Questionnaire Failed</h1>
                <div className='row'>
                    <div className='col-md-4'></div>
                    <div className='col-12 col-xs-12 col-sm-12 col-md-4'>
                    </div>
                </div>
            </div>
        )
    else
        return (
            <div className='container'>
                <br />
                <h1 align="center">Questionnaire</h1>
                <div className='row'>
                    <div className='col-md-4'></div>
                    <div className='col-12 col-xs-12 col-sm-12 col-md-4'>
                        {
                            questionnaire.data && questionnaire.data.questions.map((q, i) => {
                                return (<div className='card card-body m-3' key={i}>
                                    <div>{i + 1}. {q.question}</div>
                                    <div className='m-2'></div>
                                    {
                                        q.type === "text" && <input type='text' onChange={(e) => {
                                            let { value } = e.target
                                            let newQuestionnaireData = { ...questionnaire.data }
                                            newQuestionnaireData.questions[i]["answer"] = value
                                            setQuestionnaire({
                                                ...questionnaire,
                                                data: newQuestionnaireData
                                            })
                                        }} />
                                    }
                                    {
                                        q.type === "radio" && <div>
                                            {
                                                q.options.map((ops, j) => {
                                                    return (<div key={j}>
                                                        <input
                                                            type='radio'
                                                            value={ops.value}
                                                            onChange={(e) => {
                                                                const { checked, value } = e.target
                                                                // console.log(checked)
                                                                // console.log(value)
                                                                let newQuestionnaireData = { ...questionnaire.data }
                                                                newQuestionnaireData.questions[i].options = newQuestionnaireData.questions[i].options.map((x) => {
                                                                    let newX = { ...x }
                                                                    newX["answer"] = false
                                                                    if (checked && (value === newX.value)) newX["answer"] = true
                                                                    return newX
                                                                })
                                                            }}
                                                            name={`radio-${i}`}
                                                        />&nbsp;&nbsp;{ops.value}
                                                    </div>)
                                                })
                                            }
                                        </div>
                                    }
                                    {
                                        q.type === "checkbox" && <div>
                                            {
                                                q.options.map((ops, j) => {
                                                    return (<div key={j}>
                                                        <input type='checkbox' value={ops.value} key={j} onChange={(e) => {
                                                            const { checked, value } = e.target
                                                            // console.log(checked)
                                                            // console.log(value)
                                                            let newQuestionnaireData = { ...questionnaire.data }
                                                            newQuestionnaireData.questions[i].options = newQuestionnaireData.questions[i].options.map((x) => {
                                                                let newX = { ...x }
                                                                if (checked && (value === newX.value)) newX["answer"] = true
                                                                else if (!checked && (value === newX.value)) newX["answer"] = false
                                                                return newX
                                                            })
                                                        }} />&nbsp;&nbsp;{ops.value}
                                                    </div>)
                                                })
                                            }
                                        </div>
                                    }
                                </div>)
                            })
                        }
                        <div className='row'>
                            <div className='col-md-4'></div>
                            <div className='col-12 col-xs-12 col-sm-12 col-md-4'>
                                <div className='card card-body border-0'>
                                    <button
                                        className='btn btn-primary'
                                        disabled={isSubmit}
                                        onClick={() => {
                                            setIsSubmit(true)
                                            let isChecked = true
                                            let newQ = { ...questionnaire.data }
                                            for (let question of newQ.questions) {
                                                if (question.type === "text") {
                                                    if (question["answer"] === "") isChecked = false
                                                } else {
                                                    let haveTrue = false
                                                    for (let ops of question.options) {
                                                        if (ops.answer === true) haveTrue = true
                                                    }
                                                    isChecked = isChecked && haveTrue
                                                }
                                            }
                                            if (!isChecked) alert("Please enter form complete.")
                                            if (isChecked) {
                                                console.log(questionnaire)
                                                submitQuestionnaire(questionnaire.data._id, questionnaire.data.questions)
                                            }
                                        }}
                                    >Submit</button>
                                </div>
                                <div className='m-3'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
}
